module.exports = __webpack_public_path__ + "static/media/icon-form.4c7a2eff.svg";